export const RiskLevelEnum = {
  not_defined: 'not_defined',
  low: 'low',
  medium: 'medium',
  high: 'high',
  critical: 'critical',
  prohibited: 'prohibited',
} as const;
export type RiskLevelEnum = (typeof RiskLevelEnum)[keyof typeof RiskLevelEnum];
